import React, { useCallback } from 'react';
import { ApiAction } from '@ydistri/api-sdk';
import { Button, Row } from '@ydistri/ds';
import { useResetCategoryConfigurationsMutation } from '../../../components/global/CategoryTree/apiCategoryTree';
import { useTemplateOrCalculation } from '../../../hooks/useTemplateOrCalculation';
import { addToast } from '@ydistri/utils';
import { useAppDispatch } from '../../../store';
import useIsConfigurationEditable from '../../../hooks/useIsConfigurationEditable';

interface ResetFormCategoryProps {
  categoryId: number;
}

const ResetFormCategory: React.FC<ResetFormCategoryProps> = ({ categoryId }) => {
  const dispatch = useAppDispatch();
  const templateOrCalculation = useTemplateOrCalculation();
  const isConfigurationEditable = useIsConfigurationEditable();

  const [resetCategoryConfigurations, { isLoading: isResetting }] =
    useResetCategoryConfigurationsMutation();

  const handleClear = useCallback(() => {
    resetCategoryConfigurations({
      templateId: templateOrCalculation.id,
      categoryId,
      apiAction: ApiAction.DeleteSingleCategoryDeviations,
    })
      .then(() => {
        dispatch(addToast({ message: `Category was successfully reset` }));
      })
      .catch(() => {
        dispatch(addToast({ message: `There was an error resetting category`, isError: true }));
      });
  }, [categoryId, dispatch, resetCategoryConfigurations, templateOrCalculation.id]);

  if (templateOrCalculation.type !== 'Template') return null;

  return (
    <Row $gap="0.5rem">
      <Button
        $sizeVariant="xSmall"
        $colorVariant="ghostDanger"
        onClick={handleClear}
        loading={isResetting}
        disabled={!isConfigurationEditable}
      >
        Clear exceptions
      </Button>
    </Row>
  );
};

export default ResetFormCategory;
